import '../../css/SideBar.css';
import Button from '@mui/material/Button';

export const SideBarButton = (props) => {
  return (
    <Button
      size="large"
      variant="contained"
      sx={{
        padding: props.open ? '10px 45px' : '10px 0',
        width: props.open ? '90%' : '80%',
        bgcolor: '#2d3341',
        color: '#FFF',
      }}
      startIcon={props.iconName}
      onClick={props.clickHandler}
    >
      {props.open ? props.btnName : ''}
    </Button>
  );
};
